import React from 'react';

import TextField from './TextField';


/** Numeric input — native `<input type="number">` styled via TextField. */
const NumberField = React.forwardRef((props, ref) => {
  return (
    <TextField
      ref={ref}
      type="number"
      inputMode="decimal"
      {...props}
    />
  );
});

NumberField.displayName = 'NumberField';
export default NumberField;
